import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'utils/modifiedTranslation';
import Grid from '@material-ui/core/Grid';
import Input from '../../TextInput';
import QuestionTitle from './QuestionTitle';
import QuestionSubTitle from './QuestionSubTitle';

import QuestionOptionsContainer from './QuestionOptionsContainer';

const TextInput = ({
  question, onChange, question: { placeholder, helpText }, value = '',
}) => {
  const { t } = useTranslation();
  const defaultInputLabel = placeholder
    || 'questionnaire.questions.global.default.placeholder.typing_here';
  const {
    id, title, subtitle, label = defaultInputLabel, instruction,
  } = question;

  const onInputChage = (str) => {
    const noSpecialChars = str.replace(/[^a-zA-Z ]/g, '');
    onChange(noSpecialChars);
  };

  return (
    <Grid key={id}>
      <QuestionTitle label={title} />

      {subtitle && <QuestionSubTitle label={subtitle} />}
      <QuestionOptionsContainer>
        <Input
          type="text"
          placeholder={t(label)}
          value={value}
          helperText={instruction}
          onChange={onInputChage}
        />
        {helpText ? <p>{t(helpText)}</p> : null}
      </QuestionOptionsContainer>
    </Grid>
  );
};

TextInput.propTypes = {
  /**
   * Question object with title, subtitles, etc
   */
  question: PropTypes.object.isRequired,
  /**
   * Input placeholder
   */
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default TextInput;
